import axiosInstance from "utils/axios";
import { toast } from "sonner";

/**
 * Fetch scheduled items for My Activities.
 * POST /api/MySchedule/items
 * 
 * @param {string} startDate - YYYY-MM-DD
 * @param {string} endDate - YYYY-MM-DD
 * @param {string[]|null} types - Array of types (e.g. ["jobs", "leadActivities"]) or null
 */
export const getMyScheduledItems = async (startDate, endDate, types = null, jobFilterIds = null, leadFilterIds = null, viewMyJobs = false, viewTraderTasks = null, advancedFilters = {}) => {
  try {
    const payload = {
      startDate,
      endDate,
      types,
      jobFilterIds,
      leadFilterIds,
      viewMyJobs,
      viewTraderTasks,
      ...advancedFilters
    };

    const response = await axiosInstance.post("/api/MySchedule/items", payload);

    if (response.data.statusCode === 200 && response.data.status === "Success") {
      let parsedData = {};
      const rawData = response.data.data;
      if (typeof rawData === "string") {
        try {
          parsedData = JSON.parse(rawData);
        } catch (parseError) {
          console.error("Error parsing schedule data:", parseError);
        }
      } else if (rawData && typeof rawData === "object") {
        parsedData = rawData;
      }

      return {
        success: true,
        data: {
          jobs: parsedData?.jobs || [],
          leadActivities: parsedData?.leadActivities || [],
          jobActivities: parsedData?.jobActivities || [],
        },
        totalRecords: response.data.totalRecords || 0,
        message: response.data.message || "Scheduled items fetched successfully",
      };
    } else {
      throw new Error(response.data.message || "Failed to fetch scheduled items");
    }
  } catch (error) {
    console.error("Error fetching scheduled items:", error);

    const errorMessage = error.response?.data?.message || error.message || "Failed to fetch scheduled items";

    toast.error("Failed to load schedule data", {
      description: errorMessage,
      duration: 5000,
    });

    return {
      success: false,
      error: errorMessage,
      data: {
        jobs: [],
        leadActivities: [],
        jobActivities: [],
      },
      totalRecords: 0,
    };
  }
};
